import {reactive, toRefs, onBeforeMount, onUnmounted} from "vue";
import type {ToRefs} from "vue"
//@ts-ignore
import {BREAKPOINT} from "@customTypes/BreakpointEnum";

interface UsableBreakpoints {
    isDesktopMode: boolean;
    isSmall: boolean;
    isLarge: boolean;
    isMedium: boolean;
    isExtraLarge: boolean;
}

export function useBreakpoints(): ToRefs<UsableBreakpoints>{
    const state = reactive<UsableBreakpoints>({
        isDesktopMode: false,
        isSmall: false,
        isLarge: false,
        isMedium: false,
        isExtraLarge: false,
    })

    const setDeviceMode = (): void => {
        state.isDesktopMode = window.innerWidth > BREAKPOINT.SMALL;
        state.isSmall = window.innerWidth <= BREAKPOINT.SMALL;
        state.isMedium = window.innerWidth > BREAKPOINT.SMALL;
        state.isLarge = window.innerWidth > BREAKPOINT.MEDIUM;
        state.isExtraLarge = window.innerWidth > BREAKPOINT.LARGE;
    }

    onBeforeMount(() => {
        setDeviceMode() //Initializing the variables
        window.addEventListener("resize", setDeviceMode)
    })

    onUnmounted(() => {
        window.removeEventListener("resize", setDeviceMode)
    })

    return toRefs(state)
}
